import { ChainRegistryService } from "@umami/chains";
import { useAppSelector, useCurrentAccount, useHandleSession } from "@umami/state";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { Layout } from "../../Layout";
import { SessionLogin } from "../../views/SessionLogin/SessionLogin";
import { Welcome } from "../../views/Welcome";
import { BeaconProvider } from "../beacon";
import { StagingPasswordProtection } from "../StagingPasswordProtection";
import { WalletConnectProvider } from "../WalletConnect/WalletConnectProvider";

import { trackPageView } from "@/utils/analytics";

export const App = () => {
  const { isSessionActive, isOnboarded } = useHandleSession();
  const currentAccount = useCurrentAccount();
  const location = useLocation();
  const { configs } = useAppSelector(state => state.networks);

  // Track posthog page views
  useEffect(() => {
    trackPageView();
  }, [location]);

  // Initialize the chain registry service before the app renders
  // TODO: Come up with a better way to initialize the chain registry service
  useMemo(() => {
    ChainRegistryService.initialize(configs, currentAccount?.chains);
  }, [currentAccount?.chains, configs]);

  const appContent = () => {
    if (!isSessionActive) {
      if (isOnboarded()) {
        return <SessionLogin />;
      }

      return <Welcome />;
    } else {
      return (
        <BeaconProvider>
          <WalletConnectProvider>
            <Layout />
          </WalletConnectProvider>
        </BeaconProvider>
      );
    }
  };

  return <StagingPasswordProtection>{appContent()}</StagingPasswordProtection>;
};
